import styled from 'styled-components'

export const ModalImage = styled.img`
    display: block;
    width: 100px;
`
